import angular from 'angular';

import '../../../services/user';

angular.module('folkeuni').component('loginUserForgotPassword', {
    bindings: {
      username:'@',
      loginPageUrl: '@',
      siteId: '@'
    },
    controller: function (User) {
        var $ctrl = this;

        $ctrl.passwordForgot = function(){
          $ctrl.statusMessage = null;
          $ctrl.loading = true;
            $ctrl.success = null;
              $ctrl.error = null;
          var emailObj = {
            siteId: $ctrl.siteId,
            email: $ctrl.username
          }
          User.passwordForgot(emailObj).then(function(successResponse){
            $ctrl.loading = false;
              $ctrl.success = true;
              $ctrl.statusMessage = "Vi har sendt dig en e-mail. I e-mailen er der et link som fører dig til en side, hvor du kan indtaste et ønsket password.";
          }, function(errorResponse){
            console.log("Error",errorResponse);
            $ctrl.loading = false;
              $ctrl.error = true;
              $ctrl.statusMessage = "Der er sket en fejl i forbindelse med nulstillingen, er e-mail indtastet korrekt?";
          })
        }

    },
    templateUrl: '/shop-dist/templates/user-forgot-password.html',
    transclude: false
});
